import { createMessageGroup as e } from "../../utils/chat.js";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { createStore as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useShallow as r } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { devtools as i } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/middleware.mjs";
//#region src/lib/stores/chat-store/useChatStore.ts
var a = n(i((t, n) => ({
	chatMessages: [],
	chatMessagesNotConverted: [],
	sendingMessages: [],
	unreadMessagesIds: [],
	newMessageId: null,
	addUnreadMessageId: (e) => {
		let r = n().unreadMessagesIds;
		t({ unreadMessagesIds: [...r, e] });
	},
	addNewMessage: (e) => {
		let t = [...n().chatMessagesNotConverted, e];
		n().setChatMessages(t);
	},
	markMessageAsSent: (e) => {
		let r = n().sendingMessages;
		t({ sendingMessages: r.filter(({ id: t }) => t !== e?.id) }), n().addNewMessage(e);
	},
	setChatMessages: (r) => {
		let i = n().sendingMessages, a = [...r, ...i], o = [];
		for (a.sort((e, t) => e.timestamp - t.timestamp); a.length;) {
			let [t] = a, n = a.findIndex(({ userId: e, isSending: n }) => e !== t.userId || n);
			if (n !== -1) {
				let t = n === 0;
				o = [...o, e(a.slice(0, t ? 1 : n))], a.splice(0, t ? 1 : n);
			} else o = [...o, e(a)], a.splice(0, a.length);
		}
		t({
			chatMessages: o,
			chatMessagesNotConverted: r
		});
	},
	addSendingMessage: (e) => {
		let r = n().sendingMessages, i = n().chatMessagesNotConverted;
		t({
			sendingMessages: [...r, e],
			newMessageId: e.id
		}), n().setChatMessages(i);
	},
	resetNewMessageId: () => {
		t({ newMessageId: null });
	},
	readMessage: (e) => {
		let r = n().unreadMessagesIds;
		r.includes(e) && t({ unreadMessagesIds: r.filter((t) => t !== e) });
	},
	clear: () => {
		t({
			unreadMessagesIds: [],
			newMessageId: null,
			chatMessages: [],
			chatMessagesNotConverted: [],
			sendingMessages: []
		});
	}
}))), o = (e) => t(a, r(e));
//#endregion
export { a as chatStore, o as useChatStore };
